import {Link, LinkProps} from "@gatsbyjs/reach-router"
import {navigate} from "@reach/router"
import clsx from "clsx"
import {withPrefix} from "gatsby"
import React, {useContext} from "react"
import Ripple, {RippleColor} from "~/components/UI/Ripple/Ripple"
import TransitionContext from "~/contexts/TransitionContext"
import NavBarContext from "../../../contexts/NavBarContext"
import {ButtonColor} from "./Button"

import "./Button.css"

export interface LinkButtonProps extends Omit<LinkProps<any>, "to"> {
    color?: ButtonColor
    withoutTransition?: boolean | undefined
    to?: string | undefined | null
}

const LinkButton: React.FC<LinkButtonProps> = props => {
    const {
        color = "green",
        to = "",
        children,
        download,
        withoutTransition,
        onClick,
        className,
        ref,
        ...otherProps
    } = props
    const internal = /^\/(?!\/)/.test(to ? to : "")
    const transitionContenxt = useContext(TransitionContext)
    const navbarContext = useContext(NavBarContext)

    let rippleColor: RippleColor = "light-green"
    switch (color) {
        case "green":
            rippleColor = "light-green"
            break
        case "white":
            rippleColor = "green"
            break
        case "blue":
            rippleColor = "blue"
            break
        case "gray":
            rippleColor = "gray"
            break
        case "red":
            rippleColor = "red"
            break
    }

    const goTo = (url: string) => {
        if (!url) return
        if (withoutTransition) {
            navigate(url)
            return
        }
        transitionContenxt.navigateTo(url)
    }

    const onClickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault()
        navbarContext.hide(1000)
        if (onClick) onClick(event)
        goTo(event.currentTarget.href)
    }

    const button =
        internal && to ? (
            <Link
                className={clsx("button-8p4x", `${color}-8p4x`, className)}
                to={withPrefix(to)}
                download={download}
                target="_self"
                onClick={onClickHandler}
                {...otherProps}
            >
                {children}
            </Link>
        ) : (
            <a
                href={to ?? undefined}
                className={clsx("button-8p4x", `${color}-8p4x`, className)}
                download={download}
                target={download ? "_self" : "_blank"}
                ref={ref}
                rel="noreferrer"
                {...otherProps}
            >
                {children}
            </a>
        )

    return <Ripple color={rippleColor}>{button}</Ripple>
}

export default LinkButton
